import { createContext, useState, useEffect } from "react";
import { useNavigate } from "@/router";
import { useAuth as useKeycloakAuth } from "react-oidc-context";
import { useGetProfile } from "@/services/userService";
import { useLogout, useGetPingSWR } from "@/services/userService";

const initialState = {
    user: null,
    accessToken: null,
    isLoading: true,
    isIdpLoading: true,
    isAuthenticated: false,
    isFullyLoaded: false,
    fromIdp: null,
}

export const AuthContext = createContext({});

// eslint-disable-next-line react/prop-types
export const AuthProvider = ({ children }) => {

    const [auth, setAuth] = useState({...initialState, user: JSON.parse(window?.localStorage?.getItem('user')) || null });

    const keycloakAuth = useKeycloakAuth();
    const getProfile = useGetProfile()
    const logout = useLogout()
    useGetPingSWR(auth?.isFullyLoaded)

    const navigate = useNavigate()

    useEffect(() => {
        if (auth.user !== undefined)
            window.localStorage.setItem('user', JSON.stringify(auth.user))   
    }, [auth.user])


    useEffect(() => {
        // console.log(keycloakAuth.isLoading, keycloakAuth.isAuthenticated, keycloakAuth.user)
        if (! keycloakAuth.isLoading && keycloakAuth.isAuthenticated && keycloakAuth.user.access_token) {
            setAuth(prev => ({...prev, isIdpLoading: false, accessToken: keycloakAuth.user.access_token, isAuthenticated: true, fromIdp: true}))
        } else if (!keycloakAuth.isLoading && !keycloakAuth.isAuthenticated) {
            setAuth(prev => ({...prev, isIdpLoading: false, isAuthenticated: false, isLoading: true}))
        } else if (keycloakAuth.isLoading) {
            setAuth(prev => ({...prev, isIdpLoading: true, isLoading: true}))
        }
    }, [keycloakAuth.isLoading, keycloakAuth.isAuthenticated, keycloakAuth.user])



    useEffect(() => {
        if (auth?.accessToken) {
            setAuth(prev => ({...prev, isAuthenticated: true}))
        }
    }, [auth?.accessToken])



    useEffect(() => {

        // console.log(auth)

        const updateProfile = async () => {

            try {
                const profile = await getProfile();
                setAuth(prev => ({...prev, user: profile}))

            } catch (error) {
                if (error?.response?.status === 403) {
                    navigate('/noaccount', {replace: true})
                }
            }
        }
        
        if (auth.isAuthenticated && !auth.isLoading) {
            updateProfile()
        }

    }, [auth.isAuthenticated, auth.isLoading]) // eslint-disable-line react-hooks/exhaustive-deps

    
    
    useEffect(() => {
        if (auth.user && auth.isAuthenticated && !auth.isLoading) {
            setAuth(prev => ({...prev, isFullyLoaded: true}))
        }
    }, [auth.user, auth.isAuthenticated, auth.isLoading, auth.fromIdp])


    const setAccessToken = (token) => {
        setAuth(prev => ({...prev, accessToken: token}))
    }

    const setUser = (user) => {
        setAuth(prev => ({...prev, user: user}))
    }
    
    const setIsLoading = (isLoading) => {
        setAuth(prev => ({...prev, isLoading: isLoading}))
    }

    const logoutHandler = async () => {
        // console.log('logoutHandler::logoutHandler', auth)
        if(auth?.isAuthenticated) {
            if (auth.fromIdp) {
                // console.log('logoutHandler::logoutHandler::logout from idp')
                setAuth(prev => ({...prev, user: null}))
                await keycloakAuth.removeUser();
                await keycloakAuth.signoutRedirect();
            } else {
                // console.log('logoutHandler::logoutHandler::logout')
                await logout();
                setAuth(prev => ({...prev, isAuthenticated: false, isLoading: true, user: null, accessToken: null, isFullyLoaded: false, fromIdp: null}));
            }
        }
    }

    return (
        <AuthContext.Provider value={ {auth, setAccessToken, setUser, setIsLoading, logoutHandler} }>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;